import { ChangeDetectionStrategy, Component, HostListener } from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
  selector: "nikkan-corporate-scroll-top",
  templateUrl: "./scroll-top.component.html",
  styleUrls: ["./scroll-top.component.scss"],
  standalone: true,
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScrollTopComponent {
  windowScrolled!: boolean;

  @HostListener("document:scroll", ["$event"])
  onWindowScroll() {
    if (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop > 100) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.scrollY) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }
}
